module.exports = __webpack_public_path__ + "static/media/Saint-Laurent-Black-110mm-Opyum-Logo-Patent-Leather-Pumps-Lyst.fa22a762.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Saint-Laurent-Black-110mm-Opyum-Logo-Patent-Leather-Pumps-Lyst.png
// module id = 285
// module chunks = 0